<section class="financial-health">
    <h2 class="section-title">Your Financial Health</h2>
    <div class="financial-health__content">
        <div class="left">
            <app-credit-score
                [vantageScore]="mostRecentCreditScore"
                [isCreditScoreAvailable]="isCreditScoreAvailable"
                (onClickCreditManager)="onNavigateToBEFH()"
            ></app-credit-score>
        </div>
        <div class="right">
            <app-debt-manager class="half-column" (onClickDebtManager)="onNavigateToDebtManager()"></app-debt-manager>
            <app-money-manager class="half-column" (onClickMoneyManager)="onNavigateToMoneyManager()"></app-money-manager>
        </div>
    </div>
</section>
